export class Direction {
    get id() {
        return this.directionState.id;
    }
    get streetId() {
        return this.directionState.streetId;
    }
    get streetTypeId() {
        return this.directionState.streetTypeId;
    }
    get number() {
        return this.directionState.number;
    }
    get districId() {
        return this.directionState.districId;
    }
    get portal() {
        return this.directionState.portal;
    }
    get stairs() {
        return this.directionState.stairs;
    }
    get floor() {
        return this.directionState.floor;
    }
    get door() {
        return this.directionState.door;
    }
    get complexId() {
        return this.directionState.complexId;
    }
    get buildingId() {
        return this.directionState.buildingId;
    }
    get municipalityId() {
        return this.directionState.municipalityId;
    }
    get provinceId() {
        return this.directionState.provinceId;
    }
    get countryId() {
        return this.directionState.countryId;
    }
    get coords() {
        return this.directionState.coords;
    }
    set streetId(streetId) {
        this.directionState.streetId = streetId;
    }
    set streetTypeId(streetTypeId) {
        this.directionState.streetTypeId = streetTypeId;
    }
    set number(number) {
        this.directionState.number = number;
    }
    set districId(districId) {
        this.directionState.districId = districId;
    }
    set portal(portal) {
        this.directionState.portal = portal;
    }
    set stairs(stairs) {
        this.directionState.stairs = stairs;
    }
    set floor(floor) {
        this.directionState.floor = floor;
    }
    set door(door) {
        this.directionState.door = door;
    }
    set complexId(complexId) {
        this.directionState.complexId = complexId;
    }
    set buildingId(buildingId) {
        this.directionState.buildingId = buildingId;
    }
    set municipalityId(municipalityId) {
        this.directionState.municipalityId = municipalityId;
    }
    set provinceId(provinceId) {
        this.directionState.provinceId = provinceId;
    }
    set countryId(countryId) {
        this.directionState.countryId = countryId;
    }
    set coords(coords) {
        this.directionState.coords = coords;
    }
    constructor(directionState) {
        this.directionState = directionState;
    }
    getState() {
        return this.directionState;
    }
}
